// Lightweight entity model (Fase 3 — not a full ECS).

export type EntityKind = 'enemy' | 'boss' | 'projectile' | 'pickup' | 'effect';

export interface Entity {
  id: number;
  kind: EntityKind;
  pos: { x: number; y: number };
  vel?: { x: number; y: number };
  hp: number;
  maxHp: number;
  behaviorId: string;
  renderId: string;
  roomId: number;
  flags: number;
  data: Record<string, unknown>;
}

export interface EntityStore {
  entities: Map<number, Entity>;
  nextId: number;
}

export function createEntityStore(): EntityStore {
  return { entities: new Map(), nextId: 1 };
}

export function clearEntityStore(store: EntityStore): void {
  store.entities.clear();
  store.nextId = 1;
}

export function addEntity(store: EntityStore, partial: Omit<Entity, 'id'>): Entity {
  const id = store.nextId++;
  const entity: Entity = { ...partial, id };
  store.entities.set(id, entity);
  return entity;
}

export function removeEntity(store: EntityStore, id: number): void {
  store.entities.delete(id);
}

export function getEntitiesInRoom(store: EntityStore, roomId: number): Entity[] {
  const out: Entity[] = [];
  for (const e of store.entities.values()) {
    if (e.roomId === roomId && e.hp > 0) out.push(e);
  }
  return out;
}
